<template>
  <v-card class="asset-reconcile">
    <v-card-title>Purchase Reconciliation</v-card-title>

    <v-card-text>
      <p>This purchase has been initiated through the Buy It Now mechanism by a user on the application.</p>
      <p>To reconcile the purchase you can either <strong>confirm</strong> that payment has been recieved for this asset, or <strong>cancel</strong> the initiated purchase.</p>
    </v-card-text>

    <v-card-actions
      class="mt-3"
    >
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="confirm"
      >
        <v-icon left>
          mdi-cash-check
        </v-icon>
        Confirm Purchse
      </v-btn>
      
      <v-btn
        color="error"
        :loading="loading"
        :disabled="loading"
        @click="cancel"
      >
        <v-icon left>
          mdi-cash-remove
        </v-icon>
        Cancel Purchse
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'BuyItNowReconcileForm',

    components: {
    },

    computed: {
      ...mapGetters([
        'adminAsset'
      ]),
    },

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions([
        'buyItNowCancel',
        'buyItNowConfirm'
      ]),

      // Confirm purchase.
      confirm: function () {
        this.loading = true

        this.buyItNowConfirm(this.adminAsset.id).then(() => {
          this.loading = false
          this.$emit('dialogClose')
        })
      },

      // Cancel purchase.
      cancel: function () {
        this.loading = true

        this.buyItNowCancel(this.adminAsset.id).then(() => {
          this.loading = false
          this.$emit('dialogClose')
        })
      }
    }
  }
</script>
